import { AccessDeniedPage } from '@m3-tech/boss-ui'
import { TEST_ID_BASE, TestIdPage } from '@/constants/testIds'

/**
 * Access Denied page displayed when user lacks required feature permissions
 * to access this module.
 */
export default function AccessDenied() {
    return <AccessDeniedPage testId={`${TEST_ID_BASE}-${TestIdPage.ACCESS_DENIED}`} />
}
